// import React, { useState } from "react";

// export default function InfiniteScrollingBanner({
//   text = "",
//   speed = 20,
//   className = "",
//   heightClass = "h-12",
// }) {
//   const [paused, setPaused] = useState(false);

//   return (
//     <>
//       <style>{`
//         @keyframes marqueeSingle {
//           0% { transform: translateX(100%); }
//           100% { transform: translateX(-100%); }
//         }
//         .marquee-single {
//           white-space: nowrap;
//           display: inline-block;
//           animation: marqueeSingle var(--marquee-duration, 20s) linear infinite;
//         }
//         .paused {
//           animation-play-state: paused;
//         }
//       `}</style>

//       <div
//         className={`w-full overflow-hidden ${heightClass} ${className} bg-gray-900 text-gray-100 flex items-center`}
//         onMouseEnter={() => setPaused(true)}
//         onMouseLeave={() => setPaused(false)}
//       >
//         <span
//           className={`marquee-single ${paused ? "paused" : ""}`}
//           style={{ ["--marquee-duration"]: `${speed}s` }}
//         >
//           {text}
//         </span>
//       </div>
//     </>
//   );
// }

import React, { useState } from "react";
import { Sparkles, AlertCircle, ChevronRight } from "lucide-react";

export default function InfiniteScrollingBanner({
  text = "",
  speed = 30,
  className = "",
  heightClass = "h-16 md:h-20",
  loading = false,
}) {
  const [paused, setPaused] = useState(false);

  const scrollDuration = `${speed}s`;

  return (
    <>
      <style>{`
        @keyframes marqueeSingle {
          0% { transform: translateX(0); }
          100% { transform: translateX(-100%); }
        }
        .marquee-single {
          white-space: nowrap;
          display: inline-block;
          padding-right: 100%; /* Add space at the end for smooth loop */
          animation: marqueeSingle ${scrollDuration} linear infinite;
        }
        .marquee-single.paused {
          animation-play-state: paused;
        }
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
        
        /* For better performance */
        .marquee-container {
          will-change: transform;
        }
      `}</style>

      <div
        className={`relative w-full overflow-hidden ${heightClass} ${className} bg-gradient-to-r from-emerald-900 via-emerald-800 to-lime-800`}
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        {/* Decorative Border */}
        <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-emerald-400 via-lime-400 to-emerald-400"></div>
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-emerald-400 via-lime-400 to-emerald-400"></div>

        {/* Left Decorative Icon */}
        <div className="absolute left-4 md:left-8 top-1/2 transform -translate-y-1/2 z-10">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-gradient-to-r from-emerald-400 to-lime-400 flex items-center justify-center">
              <Sparkles className="w-4 h-4 text-white" />
            </div>
            <div className="hidden md:block">
              <span className="text-sm font-semibold text-emerald-200">
                LATEST
              </span>
            </div>
          </div>
        </div>

        {/* Banner Content */}
        <div className="h-full flex items-center">
          {loading ? (
            <div className="w-full flex items-center justify-center">
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 border-2 border-emerald-400 border-t-transparent rounded-full animate-spin"></div>
                <span className="text-emerald-200 font-medium">
                  Loading announcement...
                </span>
              </div>
            </div>
          ) : text ? (
            <div className="relative w-full overflow-hidden">
              <div
                className={`marquee-single ${
                  paused ? "paused" : ""
                } marquee-container`}
                style={{ animationDuration: scrollDuration }}
              >
                <span className="inline-flex items-center gap-6 md:gap-10 px-4 md:px-8 text-lg md:text-2xl font-bold text-white">
                  {text}
                  {/* Separator Icon */}
                  <span className="text-emerald-300">
                    <ChevronRight className="w-5 h-5 md:w-6 md:h-6" />
                  </span>
                  <span className="text-emerald-100 opacity-80">{text}</span>
                  {/* Add one more instance for seamless looping */}
                  <span className="text-emerald-300">
                    <ChevronRight className="w-5 h-5 md:w-6 md:h-6" />
                  </span>
                  <span className="text-emerald-100 opacity-80">{text}</span>
                </span>
              </div>
            </div>
          ) : (
            <div className="w-full flex items-center justify-center">
              <div className="flex items-center gap-3">
                <AlertCircle className="w-5 h-5 text-amber-300" />
                <span className="text-emerald-200 font-medium">
                  No announcements at the moment
                </span>
              </div>
            </div>
          )}
        </div>

        {/* Right Action Indicator */}
        {/* <div className="absolute right-4 md:right-8 top-1/2 transform -translate-y-1/2 z-10">
          <div
            className={`transition-all duration-300 ${
              paused ? "scale-110" : "scale-100"
            }`}
          >
            <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm">
              <span className="text-xs font-semibold text-emerald-200">
                HOVER TO PAUSE
              </span>
              <div
                className={`w-2 h-2 rounded-full ${
                  paused ? "bg-emerald-400" : "bg-lime-400 animate-pulse"
                }`}
              ></div>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
}
